import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import './App.css';

// Lazy load page components for code splitting
const HomePage = lazy(() => import('./pages/HomePage'));
const OrderPage = lazy(() => import('./pages/OrderPage'));
const OrderSuccessPage = lazy(() => import('./pages/OrderSuccessPage'));
const ContactPage = lazy(() => import('./pages/ContactPage'));
const DashboardPage = lazy(() => import('./pages/DashboardPage'));
const ProductDashboardPage = lazy(() => import('./pages/ProductDashboardPage'));
const DeliveriesPage = lazy(() => import('./pages/DeliveriesPage'));
const DesignSystemShowcase = lazy(() => import('./pages/DesignSystemShowcase'));

// Loading fallback component
const PageLoader = () => (
  <div style={{
    minHeight: '100vh',
    background: 'linear-gradient(to bottom, #fef3c7, #ffffff)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }}>
    <div style={{ textAlign: 'center' }}>
      <div style={{
        width: '3rem',
        height: '3rem',
        borderRadius: '50%',
        border: '2px solid transparent',
        borderBottomColor: '#b45309',
        animation: 'spin 1s linear infinite',
        margin: '0 auto'
      }}></div>
      <p style={{ 
        marginTop: '1rem', 
        color: '#4b5563',
        fontFamily: 'Quicksand, sans-serif'
      }}>Loading...</p>
    </div>
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/order" element={<OrderPage />} />
          <Route path="/order-success" element={<OrderSuccessPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/dashboard/products" element={<ProductDashboardPage />} />
          <Route path="/deliveries" element={<DeliveriesPage />} />
          <Route path="/design-system" element={<DesignSystemShowcase />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;